import { YYYY_MM_DD } from 'aegion_common_utilities/lib/format/datetime';
import { getDateRangeTypeMeta } from './util/DateRangeTypes';

const WITHIN_6_MONTHS = getDateRangeTypeMeta('WITHIN_6_MONTHS');

const stringifyDate = date => {
	if (date instanceof Date) {
		return YYYY_MM_DD(date);
	}
	return date;
};

export const initialState = {
	type: WITHIN_6_MONTHS.key,
	from: stringifyDate(WITHIN_6_MONTHS.computeNewFrom()),
	to: stringifyDate(WITHIN_6_MONTHS.computeNewTo()),
	enabled: false,
	isInitialized: false,
};

export default initialState;
